export default __webpack_public_path__ + "static/media/web-maintenance.af326f4d.svg";